import { render, staticRenderFns } from "./KeyPoint.vue?vue&type=template&id=4ebe7f34&"
import script from "./KeyPoint.vue?vue&type=script&lang=js&"
export * from "./KeyPoint.vue?vue&type=script&lang=js&"
import style0 from "./KeyPoint.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports